<template>
	<main>
		<div class="mb-6">
			<a href="#" @click.prevent="addBankPayment">
				<img src="/assets/images/profile/payment/bank.png" alt="" class="w-full md:w-1/3 lg:w-1/4" />
			</a>
		</div>
		<!-- <div class="mb-6">
			<a href="#" @click.prevent="addOnlinePayment">
				<img src="/assets/images/profile/payment/online-payment.png" alt="" class="w-full md:w-1/3 lg:w-1/4" />
			</a>
		</div> -->
	</main>	
</template>
<script>
	export default {
		methods: {
			addBankPayment() {
				this.$emit('addBankPayment')
			},
			addOnlinePayment() {
				this.$emit('addOnlinePayment')
			}
		}
	}
</script>